"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _constants = require("./constants");

var _default = new _immutable.Record({
  format: null,
  sampleDateString: null
}, _constants.DATETIME_FORMAT_OPTION);

exports.default = _default;
module.exports = exports.default;